import React from 'react';
import logo from '../../assets/images/loading.gif'; 

function LoadingGif() {
  return <div>
          <center>
          <span style={{"fontSize":"20px", "fontWeight":"bold"}}>Loading...</span> <br></br>
         <img src={logo} alt="Logo"  style={{"backgroundColor":"white"}}/>
         </center>
         </div>
}

export default LoadingGif;


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js